<template>
  <public-page>
    <div class="contact">
      <contact-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import ContactCard from '../cards/ContactCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'contact',
  components: {
    PublicPage,
    ContactCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/contact',
      ogTitle: 'Contact - Rewarding Dog Training',
      ogDescription: 'Contact Rewarding Dog Training. Reach out to discuss your training goals or any questions you may have.',
    })
  },
}
</script>

<style lang="scss">
</style>
